'use client';

import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { createSelectListCollection } from '../../components/select';
import {
  APPLICATION_ENVIRONMENT_VALUES,
  APPLICATION_TYPE,
} from './application-general.model';

export const useApplicationEnvironmentSelectCollection = () => {
  const t = useTranslations('designSystem.applicationGeneral.environments');

  return useMemo(
    () =>
      createSelectListCollection({
        items: APPLICATION_ENVIRONMENT_VALUES.map((value) => ({
          label: t(value),
          value,
        })),
      }),
    [t],
  );
};

export const useApplicationTypeSelectCollection = () => {
  const t = useTranslations('designSystem.applicationGeneral.applicationTypes');

  return useMemo(
    () =>
      createSelectListCollection({
        items: [
          {
            label: t(APPLICATION_TYPE.webAndBackend),
            value: APPLICATION_TYPE.webAndBackend,
          },
          {
            label: t(APPLICATION_TYPE.backendOnly),
            value: APPLICATION_TYPE.backendOnly,
          },
        ],
      }),
    [t],
  );
};
